import { render, staticRenderFns } from "./VehicleDamage.vue?vue&type=template&id=54fc7fb0&lang=pug&"
import script from "./VehicleDamage.vue?vue&type=script&lang=ts&"
export * from "./VehicleDamage.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleDamage.vue?vue&type=style&index=0&id=54fc7fb0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports